export default [
  {
    "monthlyId": "price_1HbvYgKyhaqwBaqVKQI4qbCw",
    "yearlyId": "price_1HbvYgKyhaqwBaqVlE0yX2gS",
    "name": "Starter",
    "cost": 9900,
    "seats": 5,
    "features": [
      "5 Campaigns per month",
      "$0.75 per tag",
      "Up to 5 licenses for the Taptivate platform",
      "Custom landing page per campaign",
      "Custom tags",
      "Real time reporting and analytics",
    ]
  },
  {
    "monthlyId": "price_1HbvYgKyhaqwBaqVcrzDThBy",
    "yearlyId": "price_1HbvYgKyhaqwBaqVlE0yX2gS",
    "name": "Small Business",
    "cost": 29900,
    "seats": 10,
    "features": [
      "10 Campaigns per month",
      "$0.60 per tag",
      "Up to 10 licenses for the Taptivate platform",
      "Custom landing page per campaign",
      "Custom tags",
      "Real time reporting and analytics",
    ]
  },
  {
    "monthlyId": "price_1HbvYgKyhaqwBaqV2MvxQh6s",
    "yearlyId": "price_1HbvYgKyhaqwBaqVC6mH406F",
    "name": "Business Pro",
    "cost": 79900,
    "seats": 15,
    "features": [
      "25 Campaigns per month",
      "$0.55 per tag",
      "Up to 15 licenses for the Taptivate platform",
      "Custom landing page per campaign",
      "Custom tags",
      "Real time reporting and analytics",
    ]
  }
];